// Admin.js
import React from "react";
import { Typography } from "@mui/material";

function Admin() {
  return <Typography variant="h4">Admin Screen - Work in Progress</Typography>;
}

export default Admin;
